export default function (value) {
  if (!value)
    return true;

  value = String(value).replace(/[^\d]+/g, '');

  if (!(value && value.length === 14))
    return false;

  let list = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
  ];

  if (list.indexOf(value) >= 0)
    return false;

  let size = value.length - 2;

  let numbers = value.substring(0, size);

  let digits = value.substring(size);

  let sum = 0;

  let pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  if (result != digits.charAt(0))
    return false;

  size = size + 1;

  numbers = value.substring(0, size);

  sum = 0;

  pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--;
    if (pos < 2)
      pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - sum % 11;

  return result == digits.charAt(1);
};
